
export default {
  components: { Slider: () => import('~/components/ui/slider') },
  inject: ['dummyMode'],
  data() {
    return {
      pickFilters: [
        'att_spol_dropdown',
        'att_boja_visualSwatch',
        'att_velicina_dropdown',
        'att_vrsta-podloge-za-mis_dropdown',
        'att_poklon-je-za-prigodu_multipleSelect',
        'retailPrice',
      ],

      layeredRef: 'layeredNav',
      options: [
        {
          name: 'title',
          label: 'Naslov',
          type: 'text',
        },
      ],
    }
  },
  methods: {
    currencyNameSwitch(price) {
      if (!price) return
      return price.replace('HRK', 'Kn')
    },
    pushToProductList() {
      if (this.$refs[this.layeredRef]) {
        this.$refs[this.layeredRef].pushToProductList()
      }
    },
    clearFilters() {
      if (this.$refs[this.layeredRef]) {
        this.$refs[this.layeredRef].resetFilters()
      }
    },
  },
}
